<h1>CPO Style Guidelines</h1>

<input
  type="button"
  class="button_primary button_var_1 button_right-spacing"
  value="Typography"
  (click)="jumpToSection('divTypography')"
/>
<input
  type="button"
  class="button_primary button_var_1 button_right-spacing"
  value="Colors"
  (click)="jumpToSection('divColors')"
/>

<div id="divTypography" class="section">
  <h2>Typography</h2>

  <table>
    <tr>
      <td>
        <p>
          Headers -
          <span style="font-family: 'Playfair Display'">Playfair Display</span>
        </p>
        <p>
          Body - <span style="font-family: 'Roboto', sans-serif">Roboto</span>
        </p>
        <p>
          Buttons -
          <span style="font-family: 'Roboto', sans-serif">Roboto</span>
        </p>
        <p>
          Form labels -
          <span style="font-family: 'Raleway', sans-serif"
            >Raleway, sans-serif</span
          >
        </p>
        <p>
          Code -
          <span style="font-family: 'Courier New', Courier, monospace"
            >Courier New, Courier, monospace</span
          >
        </p>
      </td>
    </tr>
  </table>
</div>

<div id="divColors" class="section">
  <h2>Colors</h2>
</div>
